__turbopack_context__.v({
  "actionButtons": "EventSignalsBar-module-scss-module__nYcTyq__actionButtons",
  "container": "EventSignalsBar-module-scss-module__nYcTyq__container",
  "innerWrapper": "EventSignalsBar-module-scss-module__nYcTyq__innerWrapper",
  "signals": "EventSignalsBar-module-scss-module__nYcTyq__signals",
});
